import React from 'react';
import { BarChart3, TrendingUp } from 'lucide-react';
import { Button } from '../Button';

export type ChartType = 'line' | 'bar';

interface ChartToggleProps {
  chartType: ChartType;
  onToggle: (type: ChartType) => void;
  className?: string;
}

export function ChartToggle({ chartType, onToggle, className = '' }: ChartToggleProps) {
  return (
    <div className={`flex items-center bg-white rounded-lg border border-[--clinqr-border] p-1 ${className}`}>
      <Button
        variant={chartType === 'line' ? 'primary' : 'ghost'}
        onClick={() => onToggle('line')}
        className={`flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-md transition-all h-8 ${
          chartType === 'line'
            ? 'bg-[--clinqr-primary] text-white shadow-sm'
            : 'text-[--clinqr-text-secondary] hover:text-[--clinqr-text-primary] hover:bg-[--clinqr-bg-subtle]'
        }`}
      >
        <TrendingUp className="w-3.5 h-3.5" />
        Line
      </Button>
      <Button
        variant={chartType === 'bar' ? 'primary' : 'ghost'}
        onClick={() => onToggle('bar')}
        className={`flex items-center gap-2 px-3 py-1.5 text-xs font-medium rounded-md transition-all h-8 ${
          chartType === 'bar'
            ? 'bg-[--clinqr-primary] text-white shadow-sm'
            : 'text-[--clinqr-text-secondary] hover:text-[--clinqr-text-primary] hover:bg-[--clinqr-bg-subtle]'
        }`}
      >
        <BarChart3 className="w-3.5 h-3.5" />
        Bar
      </Button>
    </div>
  );
}
